import * as cc from 'common/constants';

export const accountsInAvailableProductStatuses = (accounts = []) => {
  const productStatusAvailable = [
    cc.PRODUCT_STATUSES.READY,
    cc.PRODUCT_STATUSES.HALTED,
    cc.PRODUCT_STATUSES.SUPPORT,
  ];

  for (let i = accounts.length - 1; i >= 0; i--) {
    if (!productStatusAvailable.includes(accounts[i].product_status_id)) {
      return false;
    }
  }

  return true;
};

export default accountsInAvailableProductStatuses;



// WEBPACK FOOTER //
// ./src/common/utils/accountsInAvailableProductStatuses.js